module.exports = __webpack_public_path__ + "assets/img/banner-index01.972b9eb2.jpg";